<template>
  <div class="schedule container">
    <div class="row">
      <div class="col">
        <PageHeading heading="Schedule"/>
        <br />
        <table class="table table-striped" id="sched">
          <thead>
            <tr>
              <th>Date</th>
              <th>Location</th>
              <th>Chapters</th>
              <th>Top 12/16</th>
              <th>Results</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="location in schedule" :key="location.id">
              <td>{{ fmtDate(location.date) }}</td>
              <td><a :href="location.waze == '' ? '#' : location.waze">{{ location.location }}</a></td>
              <td>{{ location.chapters}}</td>
              <td :class="location.top12 ? 'green' : 'red'">{{ location.top12 ? 'Y' : 'X' }}</td>
              <td><a :href="resultUrl(location.date)">Results</a></td>
            </tr>
          </tbody>
        </table> 
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeading from '@/components/PageHeading.vue';
import axios from "axios"

export default {
  name: 'Schedule',
  components: {
    PageHeading
  },
  created() { 
    axios.get(process.env.VUE_APP_API_ROOT + "/lib/schedule.php")
    .then((response) => {
      if(response.data !== null) {
        this.schedule = response.data;
      }
    })
  },
  data: function() {
    return {
      schedule: []
    }
  },
  methods: {
    resultUrl: function(date) {
      return "/results/" + date;
    }
  }
}
</script>


<style scoped>
  .green {
    color: #37823a;
    font-weight: bold;
  }

  .red {
    color: #d23125;
    font-weight: bold;
  }
  
  thead > tr {
    border-bottom: #ECECEC
  }
</style>